__turbopack_context__.v({
  "bottom-bar": "Device-module-scss-module__GTLEkq__bottom-bar",
  "camera": "Device-module-scss-module__GTLEkq__camera",
  "iphone-14": "Device-module-scss-module__GTLEkq__iphone-14" + " " + "Device-module-scss-module__GTLEkq__marvel-device",
  "iphone-14-content": "Device-module-scss-module__GTLEkq__iphone-14-content",
  "marvel-device": "Device-module-scss-module__GTLEkq__marvel-device",
  "middle-bar": "Device-module-scss-module__GTLEkq__middle-bar",
  "notch": "Device-module-scss-module__GTLEkq__notch",
  "overflow": "Device-module-scss-module__GTLEkq__overflow",
  "screen": "Device-module-scss-module__GTLEkq__screen",
  "shadow": "Device-module-scss-module__GTLEkq__shadow",
  "shadow--bl": "Device-module-scss-module__GTLEkq__shadow--bl",
  "shadow--br": "Device-module-scss-module__GTLEkq__shadow--br",
  "shadow--tl": "Device-module-scss-module__GTLEkq__shadow--tl",
  "shadow--tr": "Device-module-scss-module__GTLEkq__shadow--tr",
  "sleep": "Device-module-scss-module__GTLEkq__sleep",
  "top-bar": "Device-module-scss-module__GTLEkq__top-bar",
  "volume": "Device-module-scss-module__GTLEkq__volume",
});
